import { useMutation } from "@apollo/react-hooks";
import { Modal, Stack, TextField } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { UPDATE_ORDER_SHIPPING_LABEL } from "../../../graphql/mutations";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";

export default function UpdateShippingLabel({
    open,
    onClose,
    value,
    ids,
    refetch,
}) {
    const [state, setState] = useState({
        labelLink: "",
        carrier: "",
        trackingCode: "",
    });

    const [setDelay] = useTimeout();
    const { setNotify, toggleToast } = useToastContext();
    const [updateShippingLabel, { loading }] = useMutation(
        UPDATE_ORDER_SHIPPING_LABEL,
        {
            onCompleted: () => {
                setNotify({ msg: "Update Shipping Label succes", err: false });
                onClose && onClose();

                setDelay(() => {
                    refetch && refetch();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    React.useEffect(() => {
        if (value?.shippingLabel) {
            const { labelLink, carrier, trackingCode } = value.shippingLabel;
            setState({ labelLink, carrier, trackingCode });
        }
    }, [value]);

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        updateShippingLabel({
            variables: {
                ids,
                shippingLabel: {
                    labelLink: state.labelLink,
                    carrier: state.carrier,
                    trackingCode: state.trackingCode,
                },
            },
        });
    }, [state, ids, updateShippingLabel, setNotify, toggleToast]);

    const handleStateChange = useCallback((value, id) => {
        setState((p) => ({ ...p, [id]: value }));
    }, []);

    return (
        <Modal
            title="Update Shipping Label"
            sectioned
            open={open}
            onClose={onClose}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <Stack vertical>
                <TextField
                    id="labelLink"
                    value={state.labelLink}
                    label="Label Link"
                    onChange={handleStateChange}
                    placeholder="Enter Label Link"
                    multiline={4}
                />
                <TextField
                    id="carrier"
                    value={state.carrier}
                    label="Carrier"
                    onChange={handleStateChange}
                    placeholder="Enter Carrier"
                />
                <TextField
                    id="trackingCode"
                    value={state.trackingCode}
                    label="Tracking Code"
                    onChange={handleStateChange}
                    placeholder="Enter Tracking Code"
                />
            </Stack>
        </Modal>
    );
}
